import { coursePlanner } from "@examspark/common/dist/utils/coursePlanner";
import { AcademicCalendar, Course, AwsExports } from "@examspark/types";

import awsconfigInternal from "../aws-exports";

export const awsconfig = awsconfigInternal as AwsExports;

export const getBucketName = () => {
  return awsconfig.aws_user_files_s3_bucket;
};

export const getBucketRegion = () => {
  return "us-east-1";
};

export const synthesizeCourseCalendar = <T extends AcademicCalendar>(
  course: Course,
  ac: T,
) => {
  const courseCalendarAlike = {
    id: ac.id,
    sk: `academic-calendar#v0`,
    workspaceId: ac.workspaceId,
    schemaVersion: ac.schemaVersion,

    name: ac.name,

    calendarId: ac.id,
    calendar: ac,
    courseId: course.id,
    course: course,

    units:
      coursePlanner({
        calendar: ac,
        unitIds: course.unitIds,
      }).units ?? [],

    additionalNonInstructionDates: [],
  };

  return courseCalendarAlike;
};
